<ion-item color="light">
  <ion-input
    [formControl]="formControl"
    [type]="props.type || 'text'"
    [placeholder]="props.placeholder"
    [attr.label-placement]="props['labelPlacement']"
    [fill]="props['fill']"
  >
    <div slot="label">
      {{ translocoService.translate(props.label!) }}
      <ion-text *ngIf="props.required" color="danger"> *</ion-text>
    </div>
  </ion-input>

  <ion-note
    *ngIf="showError"
    color="danger"
    class="text-sm w-full flex justify-center"
  >
    {{ errorMessage }}
  </ion-note>
</ion-item>